(function (app, ng) {

    app.directive("fullscreen",
        [
            "$timeout", "$window", function ($timeout, $window) {
                return {
                    link: function (scope, element) {
                        element.click(function () {
                            if (element.hasClass("view-expanded")) {
                                ng.element(".body-container").addClass("view-expanded-removed");
                                element.addClass("view-expanded-removed");

                                $timeout(function () {
                                    ng.element(".body-container").removeClass("view-expanded-removed");
                                    element.removeClass("view-expanded-removed");
                                },
                                    225);
                            }

                            ng.element(".body-container").toggleClass("view-expanded");
                            element.toggleClass("view-expanded");

                            $timeout(function () {
                                $window.dispatchEvent(new Event("resize"));
                            }, 200);
                        });
                    }
                }
            }
        ]);

})(window.app, window.angular); //jshint ignore:line